// Generic imports
import _ from 'lodash';

// Material UI imports
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

// FontAwesome imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck, faSquare, faUser, faUsers } from '@fortawesome/pro-light-svg-icons';

function OpportunitiesFilterOwner(props) {
    const { org, filter, setFilter, me, singlePick, disabled, teamLevel, noSelectionText, noMarginRight, mineText } = props;

    const myTeam = org.users.find(u => u.email === me.email)?.team;
    const teams = _(org.users).map(u => u.team).uniq().without(myTeam).value().sort();

    return (
        <Select
            sx={{ flex: 1, marginRight: noMarginRight ? '0px' : '12px', fontSize: '13px' }}
            value={!filter.members ? [] : typeof filter.members === 'string' ? [filter.members] : filter.members} 
            displayEmpty
            disabled={disabled}
            multiple={!singlePick}
            renderValue={(value) => {
                if (singlePick) {
                    if (value.length === 1) return value[0];
                    return 'Pick Owner...';
                }
                if (teamLevel) {
                    if (value.length === 0) return noSelectionText || 'All teams';
                    if (value.length === 1 && value[0] === myTeam) return 'My teams';
                    if (value.length === 1) return teamToName(value[0]);
                    return `${value.length} Selected`;
                }
                if (value.length === 0) return noSelectionText || 'All members';
                if (value.length === 1 && value[0] === me.email) return mineText || 'My opportunities';
                if (value.length === 1) return value[0];
                return `${value.length} Selected`;
            }}
            onChange={(event) => {
                const value = event.target.value;
                let splitted = typeof value === 'string' ? value.split(',') : value;
                splitted = _.compact(splitted.map(s => {
                    const team = teams.find(t => t.toUpperCase() === s.trim().toUpperCase());
                    if (team) return org.users.filter(u => u.team === team).map(u => u.email);
                    return org.users.find(u => u.email === s)?.email || null;
                }).flat());
                setFilter({ 
                    ...filter, 
                    members: splitted
                });
            }}
            MenuProps={{
                style: {
                    zIndex: 1000000,
                },
            }}
        >
            {!singlePick && !teamLevel && (
                <Box sx={{ px: '8px', py: '4px', display: 'flex', gap: '4px' }}>
                    <Button
                        size='small'
                        variant={filter.members?.length === 1 && filter.members[0] === me.email ? 'contained' : 'outlined'}
                        sx={{ flex: 1, textTransform: 'none', fontSize: '11px', borderRadius: '6px', py: '3px' }}
                        startIcon={<FontAwesomeIcon icon={faUser} style={{ fontSize: '10px' }} />}
                        onClick={(e) => {
                            e.stopPropagation();
                            setFilter({ ...filter, members: [me.email] });
                        }}
                    >
                        Mine
                    </Button>
                    <Button
                        size='small'
                        variant={!filter.members || filter.members.length === 0 ? 'contained' : 'outlined'}
                        sx={{ flex: 1, textTransform: 'none', fontSize: '11px', borderRadius: '6px', py: '3px' }}
                        startIcon={<FontAwesomeIcon icon={faUsers} style={{ fontSize: '10px' }} />}
                        onClick={(e) => {
                            e.stopPropagation();
                            setFilter({ ...filter, members: [] });
                        }}
                    >
                        Everyone
                    </Button>
                </Box>
            )}
            {!singlePick && !teamLevel && <Divider sx={{ my: '4px' }} />}
            {_.compact([myTeam, ...teams]).map(tm => {
                return [
                    <ListSubheader
                        key={tm}
                    >
                        <Button
                            variant='text'
                            size='small'
                            sx={{ pointerEvents: !!singlePick ? 'none' : 'auto' }}
                            onClick={() => {
                                if (teamLevel) {
                                    if (filter.members?.includes(tm)) {
                                        setFilter({
                                            ...filter,
                                            members: _.without(filter.members, tm)
                                        });
                                    } else {
                                        setFilter({
                                            ...filter,
                                            members: _.uniq([
                                                ...filter.members || [],
                                                tm
                                            ])
                                        });
                                    }
                                    return;
                                }
                                if (_.every(org.users.filter(u => u.team === tm), u => filter.members?.includes(u.email))) {
                                    setFilter({
                                        ...filter,
                                        members: _.without(filter.members, ...org.users.filter(u => u.team === tm).map(u => u.email))
                                    });
                                } else {
                                    setFilter({
                                        ...filter,
                                        members: _.uniq([
                                            ...filter.members || [],
                                            ...org.users.filter(u => u.team === tm).map(u => u.email)
                                        ])
                                    });
                                }
                            }}
                        >
                            {teamLevel && <FontAwesomeIcon icon={filter.members?.includes(tm) ? faSquareCheck : faSquare} />}
                            {teamLevel && <span style={{ marginLeft: '8px' }} />}
                            {teamToName(tm)}
                        </Button>
                    </ListSubheader>,
                    ...org.users.filter(u => !teamLevel && (u.team === tm)).map(u => (
                        <MenuItem key={u.email} value={u.email} sx={{ fontWeight: filter.members?.includes(u.email) ? 'bold' : 'normal' }}>
                            {!singlePick && <FontAwesomeIcon icon={filter.members?.includes(u.email) ? faSquareCheck : faSquare} />}
                            &nbsp;
                            {u.email}
                        </MenuItem>
                    ))
                ];
            }).flat()}
        </Select>
    );
}

function teamToName(team) {
    return `${team.split(':')[0]} (${team.split(':')[1] || 'missing'})`;
}

export default OpportunitiesFilterOwner;